import React, { Component } from "react"
import PropTypes from "prop-types"
import { Dropdown, Search } from "semantic-ui-react"
import shop from "shop/shop"
import { formatPrice } from "components/Price/Price"
import _ from "lodash"
import "components/Typeahead/Typeahead.css"

class Typeahead extends Component {

  state = {
    isLoading: false,
    results  : [],
    value    : this.props.defaultValue || ""
  }

  componentWillMount() {
    this.resetComponent()
  }

  handleSearchChange = ( e, { value } ) => {
    this.setState( { isLoading: true, value } )
    this.props.onChange && this.props.onChange( { value }, e )
    return shop.typeahead.loadWithProductsFromSearch( value, { artnr: this.props.artnr, count: this.props.count } )
      .then( res => res.products )
      .then( products => {
        this.setState( { isLoading: false } )
        if ( !products || products.length === 0 ) return []
        return products.map( product => {
          return {
            value      : product,
            key        : product.map_id,
            image      : product.img_src_small,
            description: product.description,
            price      : product.price && `${formatPrice( product.price )} EUR`,
            title      : createLabel( product )
          }
        } )
      } )
      .then( results => {
        this.setState( { results } )
        return { results }
      } )
      .catch( e => {
        this.setState( { isLoading: false } )
      } )
  }

  resetComponent = () => this.setState( { isLoading: false, results: [], value: "" } )

  handleResultSelect = ( e, { result } ) => {
    this.props.onSelectProduct && this.props.onSelectProduct( { product: result.value } )
    this.props.onSelect && this.props.onSelect( { product: result.value } )
    !this.props.skipProductSelection && this.setState( { value: result.value.article_nr } )
  }

  render() {
    const { label, fluid, innerRef, onFocus, resultRenderer = null, defaultValue, id = null, ...rest } = this.props
    const { isLoading, value, results } = this.state
    return (
      <Search
        ref={innerRef}
        value={value || defaultValue}
        className="Typeahead"
        id={id}
        placeholder={translate("Art.-Nr.")}
        fluid={true}
        label={label}
        onFocus={onFocus}
        selectFirstResult
        noResultsMessage={translate( "Keine Artikel gefunden" )}
        loading={isLoading}
        onResultSelect={this.handleResultSelect}
        onSearchChange={_.debounce( this.handleSearchChange, 50, { loading: true } )}
        results={results}
        resultRenderer={resultRenderer || defaultResultRenderer}
        {...rest}
      />
    )
  }
}


const defaultResultRenderer = ( entry ) => {
  return <div>{entry.title}</div>
}

Typeahead.propTypes = {
  setup: PropTypes.func
}

const createLabel = product => `${product.article_nr} ${product.title}`


export default React.forwardRef( ( props, ref ) => <Typeahead innerRef={ref} {...props}/> )

// const TESt = () =>  <Select.Async
//   onChange={this.setValue}
//   value={this.props.value}
//   arrowRenderer={arrowRenderer}
//   optionComponent={this.props.optionComponent || ProductOptiogv < n}
//   valueComponent={this.props.valueComponent || ProductValue}
//   name="form-field-name"
//   searchPromptText="Suche.."
//   loadingPlaceholder="laden.."
//   loadOptions={this.getOptions}
//   placeholder={"Art.-Nr."}
// />



// WEBPACK FOOTER //
// ./src/components/Typeahead/Typeahead.js